import { jsx as _jsx } from "react/jsx-runtime";
const SIZE_MAP = {
    body: {
        size: "var(--hydrax-type-body-size)",
        lineHeight: "var(--hydrax-type-body-line-height)",
    },
    bodySm: {
        size: "var(--hydrax-type-body-sm-size)",
        lineHeight: "var(--hydrax-type-body-sm-line-height)",
    },
};
const TONE_MAP = {
    default: "var(--hydrax-color-text)",
    muted: "var(--hydrax-color-text-muted)",
    strong: "var(--hydrax-color-text-strong)",
    danger: "var(--hydrax-color-danger)",
    success: "var(--hydrax-color-success)",
};
export function Text({ size = "body", tone = "default", family = "sans", as = "span", style, ...rest }) {
    const Tag = as;
    const tokens = SIZE_MAP[size];
    return (_jsx(Tag, { style: {
            margin: 0,
            fontFamily: family === "mono" ? "var(--hydrax-font-mono)" : "var(--hydrax-font-sans)",
            fontSize: family === "mono" ? "var(--hydrax-type-mono-size)" : tokens.size,
            lineHeight: tokens.lineHeight,
            color: TONE_MAP[tone],
            ...style,
        }, ...rest }));
}
//# sourceMappingURL=Text.js.map